// extracted by mini-css-extract-plugin
export default {"button":"_3Vad3iYI4X0QHyFMHw3AHs","circle":"_2s08gbiqxalqKPM3OzBVVY","tipBody":"_3SIO0eyfIrys3PejsYgrdf","inlineText":"_11Y7vK8PjsbV2DfHm8dKIl"};